import { memo, useEffect } from "react";
import { MiExpandableBox } from "@miplatform/components";
import { EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP } from "@miplatform/constants";
import { MiEmailInfoCard } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { useOrdersContext } from "../../../OrdersProvider";
import { useOrderInfoCardEmailsViewModel } from "./useOrderInfoCardEmailsViewModel";

export const OrderInfoCardEmails = memo(({ order, onClose }) => {
  const { handleEmailDrawerOpen, handleEmailPreviewModalOpen } =
    useOrdersContext();
  const {
    emailHistory,
    emailTemplates,
    getEmailTemplateDetails,
    getEmailHistory,
  } = useOrderInfoCardEmailsViewModel();

  useEffect(() => {
    getEmailHistory(order.id || order.orderId);
    getEmailTemplateDetails(order.orderTemplateId);
  }, [order]);

  return (
    emailTemplates.length > 0 && (
      <MiExpandableBox defaultExpanded title="Emails" sx={{ pt: 2 }}>
        <Box position="relative" display="flex" flexDirection="column" gap={1}>
          {emailTemplates.map((emailTemplate) => (
            <MiEmailInfoCard
              key={emailTemplate.emailType}
              title={EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[emailTemplate.emailType]}
              lastSent={emailHistory[emailTemplate.emailType]?.createdOn}
              isViewDisabled={!emailHistory[emailTemplate.emailType]}
              onViewClick={() => {
                handleEmailPreviewModalOpen(
                  emailHistory[emailTemplate.emailType]
                );
                onClose?.();
              }}
              onActionClick={() => {
                handleEmailDrawerOpen({
                  order,
                  templateType: emailTemplate.emailType,
                });
                onClose?.();
              }}
            />
          ))}
        </Box>
      </MiExpandableBox>
    )
  );
});
